import { isEmail } from "validator";
//import validator from 'validator';

/*export const isValidPhone = (v: string) => {
    if (!v) return false;
    //return /^[0-9\-\(\)]*\d$/.test(v);
    return /^[0-9\-\(\)\s]*\d$/.test(v);
}*/


export const isValidPhone = (v: string) => {
  if (!v) return false;
  // ↳ \(?\d{3}\)?   → optional "(", then 3 digits, then optional ")"
  //    [\s.-]?       → optional space, dot, or hyphen
  //    \d{3}         → exactly 3 digits
  //    [\s.-]?       → optional space, dot, or hyphen
  //    \d{4}$        → exactly 4 digits at the end
  return /^\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/.test(v);
};


/*
export const isValidEmail = (v: string) => {
    if (!v) return false;
    return /^[a-zA-Z0-9]+(?:\.[a-zA-Z0-9]+)*@[a-zA-Z0-9]+(?:\.[a-zA-Z0-9]+)*$/.test(v);
}
*/

export const isValidEmail = (value: string): boolean => {
  const s = value.trim();
  // reject totally empty or whitespace-only
  if (!s) return false;
  // validator.js will enforce "something@something.tld" and allow +, -, _, etc.
  return isEmail(s);
};

// Country-specific phone validators
export const phoneValidators = {
  "US": (value: string) => {
    if (!value) return false;
    // US format: (123) 456-7890 or 123-456-7890 or 123.456.7890
    return /^\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/.test(value);
  },
  "AU": (value: string) => {
    if (!value) return false;
    // Australian format: 1234 567 890 or 1234567890
    const digits = value.replace(/\D/g, '');
    return digits.length === 10;
  },
  "CA": (value: string) => {
    if (!value) return false;
    // Canadian format: (123) 456-7890 or 123-456-7890 or 123.456.7890
    return /^\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/.test(value);
  }
};

export const validatePhone = (value: string, country: string = "US") => {
  const validator = phoneValidators[country as keyof typeof phoneValidators] || phoneValidators.US;
  return validator(value);
};